import React from 'react';
import { Container, Typography, Grid, Box, Divider, useTheme, useMediaQuery } from '@mui/material';
import AppCarousel from '../../components/Carousel/AppCarousel';
import AppCard from '../../components/AppCard/AppCard';
import { apps } from '../../data/appData';
import './Home.scss';

const Home: React.FC = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    // Create a complementary color by using secondary color or a lighter shade
    const complementaryColor = theme.palette.secondary.main;
    const lightShade = theme.palette.primary.light;

    // You can choose which apps to display in the carousel
    // Option 1: Select specific apps by their IDs
    const featuredAppIds = ["tip-calc", "super-focus-time", "relaxing-sounds", "powermega-lottery", "super-word-wizard"];
    const featuredApps = apps.filter(app => featuredAppIds.includes(app.id));

    // Option 2: Or select specific indexes from the apps array
    // const featuredApps = [apps[5], apps[0], apps[6]]; // Tip Calc, Focus Time, Relaxing Sounds

    // Option 3: Or just take the first N apps (as it was before)
    // const featuredApps = apps.slice(0, 3);

    return (
        <div className="home-page">
            <section
                className="hero-section"
                style={{
                    background: theme.palette.primary.main,
                    // background: `linear-gradient(to right, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 50%, ${theme.palette.primary.main}dd 100%)`,
                    position: 'relative',
                    overflow: 'hidden',
                    color: theme.palette.primary.contrastText
                }}
            >
                {/* Add decorative elements */}
                {/* <Box
                    sx={{
                        position: 'absolute',
                        top: '-15%',
                        right: '-5%',
                        width: '300px',
                        height: '300px',
                        borderRadius: '50%',
                        background: `radial-gradient(circle, ${theme.palette.secondary.light}40 0%, transparent 70%)`,
                        zIndex: 1
                    }}
                />
                <Box
                    sx={{
                        position: 'absolute',
                        bottom: '-10%',
                        left: '10%',
                        width: '200px',
                        height: '200px',
                        borderRadius: '50%',
                        background: `radial-gradient(circle, ${theme.palette.secondary.main}30 0%, transparent 70%)`,
                        zIndex: 1
                    }}
                /> */}

                <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 2 }}>
                    <Box textAlign="center" className="hero-content">
                        <Typography
                            variant="h2"
                            component="h1"
                            gutterBottom
                            sx={{
                                position: 'relative',
                                display: 'inline-block',
                                fontWeight: 700,
                                textShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                fontSize: {
                                    xs: '2.4rem',  // Increased from 2rem to 2.4rem for mobile
                                    sm: '2.75rem', // Medium size for tablets
                                    md: '3.75rem' // Default h2 size for desktop
                                },
                                // '&:after': {
                                //     content: '""',
                                //     position: 'absolute',
                                //     width: '60%',
                                //     height: '4px',
                                //     bottom: '-8px',
                                //     left: '20%',
                                //     background: `linear-gradient(to right, ${theme.palette.secondary.light}, ${theme.palette.secondary.main})`,
                                //     borderRadius: '2px'
                                // }
                            }}
                        >
                            Innovative Mobile Apps
                        </Typography>
                        <Typography
                            variant="h5"
                            component="p"
                            gutterBottom
                            sx={{
                                maxWidth: '700px',
                                margin: '0 auto',
                                mt: 4,
                                fontWeight: 300,
                                opacity: 0.9,
                                textShadow: '0 1px 2px rgba(0,0,0,0.1)'
                            }}
                        >
                            Discover our collection of powerful, user-friendly applications
                        </Typography>
                    </Box>
                </Container>
            </section>

            <section className="featured-apps">
                <AppCarousel apps={featuredApps} />
            </section>

            <section className="all-apps">
                <Container maxWidth="lg">
                    <Box mb={4}>
                        <Typography
                            variant={isMobile ? "h5" : "h4"}
                            component="h2"
                            className="section-title"
                            sx={{
                                // '&:after': {
                                //     backgroundColor: theme.palette.primary.main
                                // },
                                fontWeight: 'bold',
                                textAlign: isMobile ? 'center' : 'left'
                            }}
                        >
                            Our Applications
                        </Typography>
                        {/* <Typography variant="h4" component="h2" gutterBottom>
                            Our Applications
                        </Typography> */}
                        {/* <Divider /> */}
                    </Box>

                    <Grid container spacing={3}>
                        {apps.map((app) => (
                            <Grid item xs={12} sm={6} md={4} key={app.id}>
                                <AppCard app={app} />
                            </Grid>
                        ))}
                    </Grid>
                </Container>
            </section>
        </div>
    );
};

export default Home;